// src/plugins/axios.js

import axios from 'axios';
// Импортируем ваш Pinia-стор, чтобы получить доступ к действию handleUnauthorized
// Убедитесь, что путь `@/stores/auth.js` верен, согласно вашим уточнениям.
import { useAuthStore } from '@/stores/auth.js';

// Создаем и конфигурируем экземпляр Axios
const instance = axios.create({
    // Базовый URL для всех API запросов
    baseURL: import.meta.env.VITE_APP_API_URL || '/api', 
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// --- Перехватчик запросов ---
// Добавляет токен авторизации (Bearer Token) к каждому исходящему запросу,
// если токен существует в Pinia-сторе.
instance.interceptors.request.use(
    (config) => {
        // Получаем инстанс стора Pinia внутри перехватчика
        const authStore = useAuthStore(); 
        const token = authStore.getToken; // Получаем токен из Pinia
        if (token) {
            // Устанавливаем заголовок Authorization
            config.headers.Authorization = `Bearer ${token}`; 
        }
        return config;
    },
    (error) => {
        // Обработка ошибок запроса (например, проблемы с сетью перед отправкой)
        return Promise.reject(error);
    }
);

// --- Перехватчик ответов ---
// Обрабатывает ответы от сервера, в частности, ошибки 401 (Unauthorized) и 403 (Forbidden).
// При таких ошибках вызывается действие handleUnauthorized из Pinia-стора.
instance.interceptors.response.use(
    (response) => {
        // Если ответ успешен, просто возвращаем его
        return response;
    },
    async (error) => { 
        // Получаем инстанс стора Pinia для доступа к действию handleUnauthorized
        const authStore = useAuthStore(); 

        // Проверяем, есть ли ответ от сервера и его статус
        if (error.response) {
            const status = error.response.status;

            // Если статус 401 (Unauthorized) или 403 (Forbidden)
            // И это не запрос на сам логин (чтобы избежать зацикливания или лишнего редиректа),
            // то есть, токен был отправлен, но оказался недействительным.
            if ((status === 401 || status === 403) && error.config.url !== `${instance.defaults.baseURL}/login`) {
                // Вызываем действие handleUnauthorized из Pinia-стора.
                // Оно очистит данные аутентификации и перенаправит пользователя.
                authStore.handleUnauthorized();
            }
        }
        // В любом случае, пробрасываем ошибку дальше для обработки в компонентах
        return Promise.reject(error);
    }
);

// Экспортируем настроенный экземпляр Axios
export default instance;
